import {InputText} from "primereact/inputtext"

export default function FulltextFilter(props) {
  return (
    <InputText value={props.value} onChange={props.onChange}
               placeholder={props.placeholder || "Fulltext"}/>
  )
}
